import React, { useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useAtomValue, useSetAtom } from 'jotai';
import { authCheckedAtom, userDataAtom } from '../../Atoms';
import useLoadUserSession from './useLoadUserSession';

const RouterLayoutWrapper = function RouterLayoutWrapper() {
  const loadUserSession = useLoadUserSession();
  const navigate = useNavigate();
  const location = useLocation();

  const userData = useAtomValue(userDataAtom);
  const setAuthChecked = useSetAtom(authCheckedAtom);

  useEffect(() => {
    // Public pages opened from a message: no session to load, nor a login to send the visitor to.
    if (
      userData ||
      location?.pathname?.includes('/landingPage') ||
      location?.pathname?.includes('/callToAction')
    ) {
      setAuthChecked(true);
      return;
    }
    loadUserSession(
      () => setAuthChecked(true),
      () => {
        setAuthChecked(true);
        navigate('/');
      }
    );
  }, []);

  return <Outlet />;
};

export default RouterLayoutWrapper;
